var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChartOff = function SvgBarChartOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12830_76488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 40V18h8v22zm12 0V20l8 8v12zm8-17.7-8-8V8h8zm12 12-8-8V26h8zm-.45 10.95L2.75 8.45 5.6 5.6l36.8 36.8z"
  }))));
};
export default SvgBarChartOff;